"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var icons_1 = require("@tiendanube/icons");
require("./Thumbnail.css");
var Thumbnail_Button_1 = __importDefault(require("./Thumbnail.Button"));
function Error(_a) {
    var aspectRatio = _a.aspectRatio, width = _a.width, src = _a.src, altText = _a.altText, onClick = _a.onClick, ariaLabel = _a.ariaLabel;
    return (React.createElement(Thumbnail_Button_1.default, { aspectRatio: aspectRatio, width: width, ariaLabel: ariaLabel, onClick: onClick },
        React.createElement("div", { className: "nimbus--thumbnail-overlay nimbus--thumbnail-overlay--white" },
            React.createElement("span", { className: "nimbus--thumbnail-error" },
                React.createElement(icons_1.ExclamationTriangleIcon, { size: "large" }))),
        React.createElement("img", { src: src, alt: altText, className: "nimbus--thumbnail" })));
}
exports.default = Error;
//# sourceMappingURL=Thumbnail.Error.js.map